module.exports = __webpack_public_path__ + "static/media/hyue.dad10a4c.png";